module.exports = __webpack_public_path__ + "static/media/nextStatusIcon.9a19278b.svg";